module.exports = __webpack_public_path__ + "img/統計学入門_5_2_問題.c9df90d1.png";